<template>
  <div id="center-chart">
    <!--    <dv-decoration-3
      style="width: 160px; height: 60px; opacity: 0.5; text-align: center"
    /> -->

    <div class="flash-title">{{ data["title"] }}</div>
    <div class="s-title">车间综合</div>
     <div style="height:80%"><dv-charts :option="option" /></div>
   <!--  <div class="s-title" style="color:#DCD803;font-size:15px;padding-right:5px;">上次更新时间<br/>{{ refreshTime}}</div> -->
  </div>
</template>

<script>
import format from "date-fns/format";
export default {
  name: "overallOee",
  props: {
    bean: {
      type: Object,
      default: function () {
        return {};
      },
    },
     updateTime:{
      type: Number,
      default: function () {
        return null;
      },
    },
  },
  data() {
    return {
      data: this.bean,
      option: {},
      refreshTime:null
    };
  },
  watch: {
    bean: {
      handler: function (val, oldVal) {
        this.data = val;
        this.createData();
      },
      deep: true,
    },
    updateTime:function (val, oldVal) {
        this.refreshTime = format(val, "HH:mm");
    },
  },
  methods: {
    createData() {
      var data = this.data;
      var value = data["value"];
      var color = value >= data["kpi"] ? "#00E690" : "red";
      this.option = {
        series: [
          {
            center: ["50%", "30%"],
            radius: "70%",
            type: "gauge",
            startAngle: -Math.PI / 2,
            endAngle: Math.PI * 1.5,
            arcLineWidth: 15,
            data: [
              {
                name: data["id"],
                value: value,
                gradient: [color],
              },
            ],
            dataItemStyle: {
              fill: "#FFF",
              fontSize: 13,
              textAlign: "right",
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            pointer: {
              show: false,
            },
            backgroundArc: {
              show: true,
              style: {
                fill: "#0B2140",
                stroke: "#0B2140",
              },
            },
            dataItemStyle: {
              lineCap: "round",
            },
            details: {
              show: true,
              valueToFixed:1,
              formatter: "{value}%",
              style: {
                fill: "#fff",
                fontSize: 35,
                fontFamily: "electronicFont",
              },
            },
          },
        ],
      };
    },
  },
  mounted() {
    //const { createData } = this
    this.createData();
    // setInterval(createData, 30000)
  },
};
</script>

<style lang="less">
#center-chart {
  width: 100%;
  box-sizing: border-box;
  margin-left: 10px;
  .flash-title {
    position: relative;
    text-align: center;
    //    top: 0.2rem;
    font-weight: bold;
    font-family: electronicFont;
    font-size: 70px;
    z-index: 1;
    text-shadow: 0 0 10px #fff, 0 0 20px #33ccff, 0 0 35px #33ccff,
      0 0 40px #33ccff;
  }
  .s-title {
    position: relative;
    text-align: center;
    font-weight: bold;
    font-size: 18px;
  }
  .update {
    position: relative;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/oee/component/overall-oee.vue